import store from "@/store";
import UserSyncWebSocketService from "./userSyncWebsocketService";
import UserSyncSSEService from "./userSyncSSEService";
import { buildClientId, buildMercureSubscribePayload, buildSseTopics } from "./userSyncProfiles";
import mercureRepository from "./repository/mercureRepository";

class UserSyncService {
	static ACTION_ENABLE_MENU_BUTTON = 0;
	static ACTION_DISABLE_MENU = 6;
	static ACTION_EVENT_WELCOME_GUEST = 23;

	constructor() {
		this.syncServices = [];
		this.eventHandler = null;
	}

	// Connects to both WebSocket and SSE simultaneously so events are received
	// regardless of which transport the scanned venue is configured to use.
	async connect({ userId }) {
		this.disconnect();

		const clientId = buildClientId(userId);
		this.eventHandler = this.handleIncomingEvent.bind(this);

		const wsService = new UserSyncWebSocketService(clientId);
		wsService.addMessageListener(this.eventHandler);
		this.syncServices.push(wsService);
		wsService.connect();

		const sseTopics = buildSseTopics(clientId);
		if (sseTopics.length > 0) {
			let mercureToken = null;
			try {
				const subscribeResult = await mercureRepository.subscribe(buildMercureSubscribePayload());
				mercureToken = subscribeResult?.token ?? null;
			} catch (e) {
				console.warn("[UserSyncService] Mercure subscribe failed, SSE will not receive private updates", e);
			}
			if (!mercureToken) {
				console.warn("[UserSyncService] No Mercure subscriber token; skipping SSE (private events would be dropped)");
				return;
			}
			const sseService = new UserSyncSSEService({ topics: sseTopics, authorization: mercureToken });
			sseService.addMessageListener(this.eventHandler);
			this.syncServices.push(sseService);
			sseService.connect();
		}
	}

	disconnect() {
		if (this.eventHandler) {
			this.syncServices.forEach((s) => {
				s.removeMessageListener(this.eventHandler);
				s.disconnect();
			});
		}
		this.syncServices = [];
		this.eventHandler = null;
	}

	handleIncomingEvent(type, data) {
		if (type !== "message" || data?.action == null) {
			return;
		}

		this.handleAction(data.action, data);
	}

	async handleAction(action, data) {
		switch (action) {
			case UserSyncService.ACTION_ENABLE_MENU_BUTTON:
			case UserSyncService.ACTION_DISABLE_MENU:
				await store.dispatch("user/loadUserReservations");
				break;

			case UserSyncService.ACTION_EVENT_WELCOME_GUEST:
				store.commit("wePass/setEventWelcome", data.data);
				break;

			default:
				break;
		}
	}
}

export default new UserSyncService();
